import { useCallback, useState } from 'react';
import { AgencyTaskSchema } from '@ametista-ai/api-schema';
import { useTranslation } from 'react-i18next';
import { Box, Button, Group } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { PostResponse } from '@/queries/posts/usePost';
import { useCreatePostTask } from '@/queries/postTasks/useCreatePostTask';
import { PostChecklistItemForm } from './PostChecklistItemForm';

export function PostChecklistAddItem({ post }: { post: PostResponse }) {
  const [isEditing, setIsEditing] = useState(false);
  const { t } = useTranslation();
  const { mutateAsync: createTask, isPending: isCreating } = useCreatePostTask();

  const handleAdd = useCallback(
    async (item: Partial<AgencyTaskSchema>) => {
      try {
        await createTask({
          title: '',
          ...item,
          postId: post.post.id,
        });
        setIsEditing(false);
      } catch {
        showNotification({
          title: 'Error creating task',
          message: 'Please try again',
          color: 'red',
        });
      }
    },
    [post.post.id, createTask]
  );

  const handleCancel = useCallback(() => {
    setIsEditing(false);
  }, []);

  return (
    <Group gap="xs" align="flex-start">
      <Box w={20}></Box>
      {isEditing ? (
        <PostChecklistItemForm
          onChange={handleAdd}
          onCancel={handleCancel}
          tasks={post.postTasks}
          isSaving={isCreating}
        />
      ) : (
        <Button size="xs" variant="outline" onClick={() => setIsEditing(true)}>
          {t('posts.add-item')}
        </Button>
      )}
    </Group>
  );
}
